import { ToggleButton } from "@fluentui/react-components";
import { ToggleItemData, ToggleListViewProps } from "./types";
import { useStyle } from "./style";

export const ToggleListView = <T,>(props: ToggleListViewProps<T>) => {
	const { selected, items, onToggle } = props;
	const classes = useStyle();

	return (
		<div className={classes.container}>
			{items.map((item: ToggleItemData<T>) => (
				<ToggleButton
					key={`${item.key}`}
					aria-label="Icon only"
					checked={item.key === selected}
					icon={item.icon}
					shape="circular"
					onClick={() => {
						if (item.onClick) {
							item.onClick();
						}

						onToggle(selected === item.key ? undefined : item.key);
					}}
					appearance={"subtle"}
					style={{
						backgroundColor:
							item.key === selected
								? "var(--colorNeutralBackground1)"
								: "transparent",
					}}
					disabled={item.disabled ?? false}
				>
					{item.text}
				</ToggleButton>
			))}
		</div>
	);
};
